@let details = volunteerDetails();

@if(details?.mentorSchedule; as schedule){
<schedule-viewer-part [selectedSlots]="schedule.selectedMeetingSlots" [numMeetings]="schedule.numMeetings" [timeZoneId]="details.standardFourTimeZoneId">
</schedule-viewer-part>
} @else {
<common-message alertType='info'>
	No Schedule added for this Volunteer, edit ability coming soon!
</common-message>
}